module.exports = "precision highp float;\nvarying vec3 vUv;\n\nvoid main() {\n    gl_FragColor = vec4(1.);\n}"